import React, { useState, useEffect } from 'react';
import Modal from '../Modal';

const OrderValueApprovalModal = ({ 
  isOpen, 
  onClose, 
  currentAmount, 
  onApprove, 
  onReject,
  orderId 
}) => {
  const [editedAmount, setEditedAmount] = useState('');

  // Reset edited amount when modal opens
  useEffect(() => {
    if (isOpen && currentAmount !== undefined && currentAmount !== null) {
      setEditedAmount(String(currentAmount));
    }
  }, [isOpen, currentAmount]);

  const handleApprove = () => {
    onApprove(orderId, editedAmount);
    onClose();
  };

  const handleReject = () => {
    onReject(orderId);
    onClose();
  };

  const handleClose = () => {
    setEditedAmount(currentAmount); // Reset to original
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Review Order Value">
      <div className="approval-modal-content">
        <div className="current-amount-section">
          <label className="amount-label">Current Amount:</label>
          <div className="current-amount">₹{currentAmount}</div>
        </div>
        
        <div className="edit-amount-section">
          <label htmlFor="edited-amount" className="amount-label">
            New Amount (if different):
          </label>
          <input
            id="edited-amount"
            type="text"
            value={editedAmount}
            onChange={(e) => setEditedAmount(e.target.value)}
            placeholder="Enter new amount"
            className="amount-input"
          />
        </div>

        <div className="modal-actions">
          <button 
            className="modal-reject" 
            onClick={handleReject}
          >
            Reject
          </button>
          <button 
            className="modal-confirm" 
            onClick={handleApprove}
            disabled={!String(editedAmount).trim()}
          >
            Approve
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default OrderValueApprovalModal; 